import { useEffect, useMemo, useState } from "react";
import { useFetchTimezoneListQuery } from "store/services/user.service";
import Select from "react-select";

const TimezoneSelect = ({ gmtOffset, handleChange }) => {
  const [selectedTimezone, setSelectedTimezone] = useState(null);

  const { data: timezones, error, isLoading } = useFetchTimezoneListQuery();

  const timezoneOptions = useMemo(() => {
    if(!timezones?.length) {
      return [];
    }
    return timezones.map((timezone) => ({
      value: timezone?.offset,
      label: `${timezone?.offset} ${timezone?.name}`,
    }));
  }, [timezones]);

  useEffect(() => {
    if(!gmtOffset || !timezones?.length) {
      return;
    }
    const timezone = timezones.find(
      (tz) => tz?.offset === gmtOffset
    );
    setSelectedTimezone(
      timezone ? { value: timezone.offset, label: `${timezone?.offset} ${timezone?.name}` } : null
    );
  }, [gmtOffset, timezones]);

  const handleTimezoneSelect = (timezone) => {
    handleChange("gmtOffset")({
      target: {
        value: timezone?.value
      }
    })
    setSelectedTimezone(timezone);
  }

  return (
    <Select
      id="timezone"
      name="timezone"
      value={selectedTimezone}
      options={timezoneOptions}
      onChange={handleTimezoneSelect}
      placeholder="Select a timezone"
      className="react-select-container"
      classNamePrefix="react-select"
    />
  )
}

export default TimezoneSelect;